import { makeStyles, createStyles } from '@material-ui/core/styles';

const page404Style = makeStyles(() =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      textAlign: 'center',
      height: 'calc(100vh - 141px)',
    },
    notFound: {
      margin: 'auto',
      fontSize: '2em',
      textTransform: 'uppercase',
    },
  })
);

export default page404Style;
